import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, UntypedFormArray, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { CustomFormField } from 'src/app/models/custom-form.model';
import { SelectOption } from '../../models/select-option.model';

@Component({
    selector: 'app-request-documentation-dialog',
    templateUrl: './request-documentation-dialog.component.html',
    styleUrls: ['./request-documentation-dialog.component.scss']
})
export class RequestDocumentationDialogComponent implements OnInit {

    newFormFG = new UntypedFormGroup({
        descripcion: new UntypedFormControl('', []),
        campos: new UntypedFormArray([], [(control: UntypedFormArray) => control.length ? undefined : { minFields: true }])
    });

    fieldTypes: SelectOption[] = [
        { codigo: 'INPUT', descripcion: 'Campo de texto' },
        { codigo: 'UPLOAD', descripcion: 'Documento' },
    ];

    get camposArray() {
       return this.newFormFG.get('campos') as UntypedFormArray;
    }

    get camposArrayControls() {
        return this.camposArray.controls as UntypedFormGroup[];
    }

    constructor(
        private dialogRef: MatDialogRef<RequestDocumentationDialogComponent>,
    ) { }

    ngOnInit(): void {
        this.addField();
    }

    cerrarDialogo(response?: { campos: CustomFormField[], descripcion?: string } | undefined) {
      this.dialogRef.close(response);
    }

    addField() {
        this.camposArray.push(new UntypedFormGroup({
            nombre: new UntypedFormControl('', [Validators.required]),
            descripcion: new UntypedFormControl('', []),
            tipo: new UntypedFormControl('INPUT', [Validators.required]),
        }));
    }

    deleteField(i: number) {
        this.camposArray.removeAt(i);
    }

    requestDocumentation() {
        this.newFormFG.markAllAsTouched();
        if (this.newFormFG.valid) {
            this.cerrarDialogo(this.newFormFG.getRawValue());
        }
    }
}
